import React from 'react'
import moment from 'moment'

const {format} = Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP'
})

const ProjectFinancialSummary = (props) => {

    
    //const totalExpenditure = props.total_fees + props.total_supplier_invoiced
    //const profit = props.total_budget - totalExpenditure
    const percentProfit = props.percent_profit * 100;
    //const leftToInvoice = (props.total_budget || 0) - (props.total_invoiced || 0)
    const supplierInvoices = props.supplier_invoices.reduce((carry, invoice) => {
        carry[invoice.client.client_id] = (carry[invoice.client.client_id]) 
            ? {
                name: invoice.client.name,
                total: carry[invoice.client.client_id].total + invoice.invoice_total
            }
            : {
                name: invoice.client.name,
                total: invoice.invoice_total
            }
        return carry
    }, {})

    return(

        <div className="d-flex flex-column justify-content-center" style={{flex: 1}}>
            <div className="d-flex flex-row justify-content-between" style={{flex: 1}}>
                <span className="lead"><strong>Date Commenced:</strong></span>
                <span className="lead">{props.first_timesheet_date ? moment(props.first_timesheet_date).format('DD/MM/YYYY') : 'N/A'}</span>
            </div>
            <div className="d-flex flex-row justify-content-between" style={{flex: 1}}>
                <span className="lead"><strong>Total Budget:</strong></span>
                <span className="lead">{format(props.total_budget)}</span>
            </div>
            <div className="d-flex flex-row justify-content-between" style={{flex: 1}}>
                <span className="lead"><strong>UK Expenditure:</strong></span>
                <span className="lead">{format(props.total_fees)}</span>
            </div>
            <div className="d-flex flex-column">
                <div className="d-flex flex-row justify-content-between" style={{flex: 1}}>
                    <span className="lead"><strong>Supplier Costs:</strong></span>
                    <span className="lead">{format(props.total_supplier_invoiced)}</span>
                </div>
                {Object.keys(supplierInvoices).map(clientId => (
                    <div className="d-flex flex-row justify-content-between pl-2 pr-2">
                        <small>{supplierInvoices[clientId].name}</small>
                        <small>{format(supplierInvoices[clientId].total)}</small>
                    </div>
                ))}
            </div>
            <div className="d-flex flex-row justify-content-between" style={{flex: 1}}>
                <span className="lead"><strong>Total Expenditure:</strong></span>
                <span className="lead">{format(props.total_expenditure)}</span>
            </div>
            <div className="d-flex flex-row justify-content-between" style={{flex: 1}}>
                <span className="lead"><strong>Total Invoiced:</strong></span>
                <span className="lead">{format(props.total_invoiced)}</span>
            </div>
            <div className="d-flex flex-row justify-content-between" style={{flex: 1}}>
                <span className="lead"><strong>Amount left to Invoice:</strong></span>
                <span className="lead">{format(props.amount_left_to_invoice)}</span>
            </div>
            <div className="d-flex flex-row justify-content-between" style={{flex: 1}}>
                <span className="lead"><strong>Credit Notes:</strong></span>
                <span className="lead">{format(props.total_credit_notes)}</span>
            </div>
            <div className="d-flex flex-row justify-content-between" style={{flex: 1}}>
                <span className="lead"><strong>Profit:</strong></span>
                <span className="lead">{format(props.profit)}</span>
            </div>
            <div className="d-flex flex-row justify-content-between" style={{flex: 1}}>
                <span className={`lead ${!isNaN(percentProfit) && percentProfit < 25 && 'text-danger'}`}><strong>% Profit:</strong></span>
                <span className={`lead ${!isNaN(percentProfit) && percentProfit < 25 && 'text-danger'}`}>{isNaN(percentProfit) ? 'N/A' : `${percentProfit.toFixed(2)}%`}</span>
            </div>
        </div>

    )

}

export default ProjectFinancialSummary